package pl.nickers.match3.ecs

/**
 * Subphase dispatcher for the 4-phase cycle:
 * INPUT → ANIMATE → GRAVITY* → RESOLVE (ordered subphases with early-return) → …
 * Uses [BoardStateComponent.didWork] as the early-return signal and ordered [ResolveSubphase]
 * values for the RESOLVE cycle.
 */
internal class GameLoopSystem : BaseSystem() {
    override fun initialize() {}

    override fun processSystem() {
        val board = world.boardState() ?: return
        dispatchNewMachine(board)
    }

    private fun dispatchNewMachine(board: BoardStateComponent) {
        val didWork = board.didWork
        board.didWork = false
        when (board.phase) {
            GamePhase.INPUT -> {
                if (didWork) board.phase = GamePhase.ANIMATE
            }
            GamePhase.ANIMATE -> {
                if (!world.anyAnimInFlight()) {
                    board.phase = GamePhase.GRAVITY
                }
            }
            GamePhase.GRAVITY -> {
                if (world.anyAnimInFlight()) {
                    board.phase = GamePhase.ANIMATE
                } else {
                    board.phase = GamePhase.RESOLVE
                    board.currentSubphase = ResolveSubphase.SWAP
                }
            }
            GamePhase.RESOLVE -> {
                if (didWork) {
                    if (world.anyAnimInFlight()) {
                        board.phase = GamePhase.ANIMATE
                    } else {
                        // Cells cleared/positions changed; run gravity before next RESOLVE cycle.
                        board.phase = GamePhase.GRAVITY
                    }
                } else {
                    val next = nextSubphase(board.currentSubphase)
                    if (next != null) {
                        board.currentSubphase = next
                    } else {
                        // All subphases no-op → nothing happened this cycle → INPUT.
                        board.phase = GamePhase.INPUT
                        board.currentSubphase = null
                    }
                }
            }
            else -> {
                board.phase = GamePhase.INPUT
                board.currentSubphase = null
            }
        }
    }

    private fun nextSubphase(current: ResolveSubphase?): ResolveSubphase? {
        val values = ResolveSubphase.values()
        if (current == null) return values.first()
        val idx = values.indexOf(current)
        return if (idx < 0 || idx >= values.size - 1) null else values[idx + 1]
    }
}
